import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { RWebShare } from "react-web-share";
import { Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { bindActionCreators } from "redux";
import Swal from "sweetalert2";
import { requestSalesAll, requestBorzoDelivery, requestSendBill, requestPayments } from "../../Redux/actions";
import Sidebar from './../Sidebar';
import '../../Admin/style.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//import { DataTable, Header, HeaderRow, HeaderCell, Body, Row, Cell, } from '@table-library/react-table-library/table';
import DataTable from 'react-data-table-component';
import ContactView from "./../ContactBook/ContactView";
import ProductCart from "./../Cart/ProductCart";

function SaleList(props) {
    const params = useParams();
    const [jobs, setjobs] = useState([]);
    // const [pagination, setpagination] = useState({});
    const navigate = useNavigate();
    const [pages, setpages] = useState([]);
    const [page_size, setpage_size] = useState(10);
    const [change, setchange] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [search, setSearch] = useState('');
    const [filter, setFilter] = useState([]);
    const [logindetails, setlogindetails] = useState({});
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const [id, setid] = useState(0);
    const [statusmodal, setstatusModal] = useState(false);
    const [contactmodal, setcontactModal] = useState(false);
    const [productModal, setproductModal] = useState(false);
    const [clientName, setclientName] = useState('');
    const [statusdata, setstatusdata] = useState({ status: 0 });
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const columns = [
        {
            name: 'Select',
            cell: item => <div>
                <Checkbox id={item.id} name="select" value={item.id} onChange={() => handleCheckboxChange(item.id)} isChecked={selectedCheckboxes.includes(item.id)}></Checkbox>
            </div>,
            selector: item => item.id,
            width: '1%'
        },
        {
            name: 'Dates',
            cell: item => <div><h6>{item.date.substring(0, 10)}  {item.date.substring(11, 19)}</h6></div>,
            selector: item => item.date,
            width: '15%'
        },
        {
            name: 'Customer',
            cell: item => <div><a href={'/admin/viewCompany/' + item.clientId}></a>
                <div>
                    <a onClick={() => { contacttoggle(item.clientId); }}>
                        <button
                            class={'badge ' + (item.status === "Delivered" ? 'badge-opacity-success' : item.status === "Pending" ? 'badge-opacity-dark' : 'badge-opacity-light')}
                            style={{ border: "0px" }}
                        >{item.client_name}
                        </button>
                    </a>
                    {contactmodal === true && (
                        <Modal
                            isOpen={contactmodal}
                            toggle={contacttoggle}
                        >
                            <ModalHeader toggle={contacttoggle}>
                                Contact Details
                            </ModalHeader>
                            <ModalBody>
                                <ContactView props={id}></ContactView>
                            </ModalBody>
                        </Modal>
                    )}
                    <p>
                        <i class="fa fa-phone"></i> <a href={`callto:${item.client_mobile}`}>{item.client_mobile}</a>
                    </p>
                </div>
            </div>,
            selector: item => item.clientId,
            width: '18%'
        },
        {
            name: 'Amount',
            cell: item => <div><h6>{item.grandTotal}</h6>{item.balance != 0 ? <p>Balance: {item.balance} </p> : ""}</div>,
            selector: item => item.grandTotal,
            width: '10%'
        },
        {
            name: 'Quantity',
            cell: item => <div><h6>{item.totalQty}</h6></div>,
            selector: item => item.totalQty,
            width: '10%'
        },
        {
            name: 'Status',
            cell: item => <div><h6>{item.status}</h6></div>,
            selector: item => item.status,
            width: '10%'
        },
        {
            name: (<div style={{ lineHeight: '1.2', textAlign: 'center' }}>Delivery <br />Slot</div>),
            cell: item => <div><h6>{item.deliverySlot}</h6></div>,
            selector: item => item.deliverySlot,
            width: '10%'
        },
        {
            name: (<div style={{ lineHeight: '1.2', textAlign: 'center' }}>
                Payment<br />Link
            </div>),
            width: '5%',
            cell: item => <div>
                {item.grandTotal !== item.paid ?
                    <button
                        onClick={() => {
                            navigator.clipboard.writeText(item.link);
                            alert('Link copied to clipboard!');
                        }}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#007bff',
                            fontSize: '16px'
                        }}
                        title="Copy to clipboard"
                    >
                        <i class="fa fa-link"></i>
                    </button> : ""
                }
            </div>,
            selector: item => item.status,
            width: '10%'
        },
        {
            name: 'Action',
            cell: item => <div>
                {statusmodal === true && (
                    <Modal
                        isOpen={statusmodal}
                        toggle={statustoggle}
                    >
                        <ModalHeader toggle={statustoggle}>
                            Change Status of the Job
                        </ModalHeader>
                        <ModalBody>
                            <form class="forms-sample">
                                <div class="item">
                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <label>Status</label>
                                            <select
                                                class="form-select"
                                                name="status"
                                                value={statusdata.status}
                                                onChange={event => onchangestatusdata(event, item.status)}
                                            >
                                                <option value="Pending">Pending</option>
                                                <option value="Delivered">Delivered</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    type="submit" class="btn btn-primary me-2" onClick={savestatustoggle} >
                                    Submit
                                </button>
                                <button
                                    class="btn btn-light"
                                    onClick={statustoggle}
                                >
                                    Cancel
                                </button>
                            </form>
                        </ModalBody>
                    </Modal>
                )}
                {JSON.parse(localStorage.getItem("user")).data.cart_delete != 0 ?
                    <button class="badge badge-opacity-danger" style={{ border: "0px", background: "#fea8a9", marginLeft: "5px", }}
                        onClick={() => { deletedata(item.cartId); }}><i class="fa fa-trash"></i></button> : ''
                }
                <button class="badge" style={{ border: "0px", background: "#1565C0", marginLeft: "5px", }}
                    onClick={() => { handlePrint(item.token); }}><i class="fa fa-print"></i></button>
            </div>,
            selector: item => item.id,
            width: '10%'
        },
    ];

    const handlePrint = (token) => {
        navigate(`/invoiceprint/${token}`);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0'); // Ensures 2 digits
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = date.getFullYear();

        return `${day} / ${month} / ${year}`;
    };

    useEffect(() => {
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            setlogindetails(data1);
            props.requestSalesAll({
                //      token: localStorage.getItem('companyToken'),
                token: '611337539322',
                page: params.page,
                page_size: params.page_size,
                search: '-'
            });
        }
        setpage_size(params.page_size);
    }, [params.page, params.page_size, change]);

    useEffect(() => {
        if (props.data && props.data.salesAllData) {
            setjobs(props.data.salesAllData.data.data);
            setTotalRows(props.data.salesAllData.data.cart.totalCount);
            setFilter(props.data.salesAllData.data.data);
        }
    }, [props.data.salesAllData]);

    const handlePageChange = page => {
        console.log(page);
        props.requestCarts({
            page: page,
            page_size: page_size,
            search: ''
        });
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setpage_size(newPerPage);
        props.requestCarts({
            page: page,
            page_size: newPerPage,
            search: ''
        });
    }

    function printPage() {
        var printContents = "<br/><center><h3>Jobs</h3></center>" + document.getElementById("printme").innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    // Function to handle individual checkbox change
    const handleCheckboxChange = (id) => {
        console.log("Checkbox clicked:", id);
        const updatedCheckboxes = selectedCheckboxes.includes(id)
            ? selectedCheckboxes.filter((checkboxId) => checkboxId !== id)
            : [...selectedCheckboxes, id];
        setSelectedCheckboxes(updatedCheckboxes);
    };

    const Checkbox = ({ id, isChecked, onChange, name, value }) => (
        <input type="checkbox" name={name} value={value} id={id} checked={isChecked} onChange={() => onChange(id)} />
    );

    // Function to handle "Select All" checkbox change
    const handleSelectAllChange = () => {
        const allCheckboxIds = filter.map((item) => item.id);
        setSelectedCheckboxes((prevSelected) =>
            prevSelected.length === allCheckboxIds.length ? [] : allCheckboxIds
        );
    };

    const tableHeaderStyle = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    }

    const contacttoggle = (id) => {
        if (contactmodal === true) {
            setcontactModal(!contactmodal);
        } else {
            setcontactModal(!contactmodal);
            setid(id);
        }
    };

    const producttoggle = (id, name) => {
        if (productModal === true) {
            setproductModal(!productModal);
        } else {
            setproductModal(!productModal);
            setid(id);
            setclientName(name);
        }
    };

    const statustoggle = (id) => {
        if (statusmodal === true) {
            setstatusModal(!statusmodal);
        } else {
            setstatusModal(!statusmodal);
            setid(id);
            //        setstatusdata({ status: 0 });
            // props.requestStatusCartUpdate({
            //   param1: id,
            //   param2: statusdata.status,
            //   token: logindetails.token,
            // });
        }
    };

    const savestatustoggle = (e) => {
        e.preventDefault();
        props.requestStatusCartUpdate({
            data: {
                param1: id.toString(),
                param2: statusdata.status,
                token: logindetails.data.userToken
            },
        });
        console.log(logindetails.data.userToken);
        setid(0);
        statustoggle();
    }

    const onchangestatusdata = (event, param1) => {
        setstatusdata((statusdata) => ({
            ...statusdata,
            [event.target.name]: event.target.value,
        }));
    };

    function deletedata(id) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {

                props.requestCartDelete({
                    data: {
                        userToken: logindetails.data.userToken,
                        cart_id: id.toString()
                    },
                });
            }
        })
    }

    //delete
    useEffect(() => {
        let deleteCartData = props.data.deleteCartData;
        if (deleteCartData !== undefined) {
            if (deleteCartData.data) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Job deleted successfully..',
                    icon: 'success'
                });
                setchange(!change)
            }
        }
        props.data.deleteCartData = undefined;
    }, [props.data.deleteCartData]);

    const HandleSendBill = () => {
        if (selectedCheckboxes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one job to send bill.',
            });
            return;
        }
        Swal.fire({
            title: 'Send Bill',
            text: `Are you sure you want to send bill for ${selectedCheckboxes.length} selected job(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, send bill!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestSendBill({
                    data: {
                        param2: selectedCheckboxes.join(','),
                        //      token: localStorage.getItem('companyToken'),
                        param1: '611337539322',
                        token: logindetails.data.userToken
                    },
                });
                // Swal.fire(
                //   'Bill Sent!',
                //   `${selectedCheckboxes.length} job(s) have been sent for billing.`,
                //   'success'
                // );
            }
        });
    };

    useEffect(() => {
        let resData = props.data.sendBillWhatsAppData;
        console.log(resData);
        if (resData !== undefined) {
            if (resData.data.status === 1) {
                Swal.fire(
                    'Bill Sent!',
                    `${selectedCheckboxes.length} Invoice(s) have been sent on Whats App.`,
                    'success'
                );
                setchange(!change)
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: resData.data.message,
                });
            }
        }
        props.data.sendBillWhatsAppData = undefined;
    }, [props.data.sendBillWhatsAppData]);

    const HandleBorzoRequest = () => {
        if (selectedCheckboxes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one job to request Borzo delivery.',
            });
            return;
        }
        Swal.fire({
            title: 'Borzo Request',
            text: `Are you sure you want to request Borzo delivery for ${selectedCheckboxes.length} selected job(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, request Borzo delivery!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestBorzoDelivery({
                    data: {
                        param2: selectedCheckboxes.join(','),
                        //      token: localStorage.getItem('companyToken'),
                        param1: '611337539322',
                        token: logindetails.data.userToken
                    },
                });
                // Swal.fire(
                //   'Borzo Delivery Requested!',   
                //   `${selectedCheckboxes.length} job(s) have been requested for Borzo delivery.`,
                //   'success'
                // );
            }
        });
    };


    useEffect(() => {
        let borzoData = props.data.borzoDeliveryData;
        console.log("Borzo Data", borzoData);
        if (borzoData !== undefined) {
            if (borzoData.data.status === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Borzo request sent successfully.',
                    icon: 'success'
                });
                setchange(!change);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: borzoData.data.message,
                    icon: 'error'
                });
            }
            props.data.borzoDeliveryData = undefined;
        }
    }, [props.data.borzoDeliveryData]);

    const HandlePaymentRequest = () => {
        if (selectedCheckboxes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No Selection',
                text: 'Please select at least one job to request payment.',
            });
            return;
        }
        Swal.fire({
            title: 'Payment Request',
            text: `Are you sure you want to request payment for ${selectedCheckboxes.length} selected job(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, request payment!'
        }).then((result) => {
            if (result.isConfirmed) {
                props.requestPayments({
                    data: {
                        param1: selectedCheckboxes.join(','),
                        //      token: localStorage.getItem('companyToken'),
                        param2: '611337539322',
                        token: logindetails.data.userToken
                    },
                });
                // Swal.fire(
                //   'Payment Requested!',
                //   `${selectedCheckboxes.length} job(s) have been requested for payment.`,
                //   'success'
                // );
            }
        });
    };

    useEffect(() => {
        let paymentData = props.data.razorData;
        if (paymentData !== undefined) {
            if (paymentData.data === 1) {
                Swal.fire({
                    title: 'Good job!',
                    text: 'Payment request sent successfully.',
                    icon: 'success'
                });
                setchange(!change);
            } else {
                Swal.fire({
                    title: 'Error!',
                    text: paymentData.data.message,
                    icon: 'error'
                });
            }
            props.data.razorData = undefined;
        }
    }, [props.data.razorData]);

    const handleSearch = (event) => {
        console.log(event.target.value);
        setSearch(event.target.value);
    };

    const conditionalRowStyles = [
        {
            when: row => row.razorpayStatus === 'paid',
            style: {
                backgroundColor: '#d4edda', // light green
                color: '#155724',           // dark green text
                fontWeight: 'bold'
            }
        }
    ];

    return (
        <>
            <div class="container-scroller">
                {/* <PageHeader name="Jobs" /> */}
                <div class="container-fluid page-body-wrapper">
                    <Sidebar name="Jobs" />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="home-tab">
                                        <div class="row flex-grow">
                                            <div class="col-12 grid-margin stretch-card">
                                                <div class="card card-rounded">
                                                    <div class="card-body">
                                                        <div class="d-sm-flex justify-content-between align-items-start">
                                                            <div class="btn-wrapper">
                                                                <RWebShare
                                                                    data={{
                                                                        text: "BookkeeperDay - Your Personal Bookkeeping App",
                                                                        url: `${baseUrl}/salelist/${params.page}/${params.page_size}`,
                                                                        title: "Sale List",
                                                                    }}
                                                                >
                                                                    <p class="btn btn-otline-dark align-items-center"><i class="icon-share"></i> Share</p>
                                                                </RWebShare>
                                                                <button onClick={printPage} class="btn btn-otline-dark"><i class="icon-printer"></i> Print</button>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="row">
                                                                <div><label htmlFor="search">Status Color codes : </label>
                                                                    <button class='badge' style={{ border: "0px", backgroundColor: '#d4edda', color: '#155724' }}>Paid</button>
                                                                    <button class='badge badge-opacity-success' style={{ border: "0px" }}>Fullfilled</button>
                                                                    <button class='badge badge-opacity-dark' style={{ border: "0px" }}>Pending</button>
                                                                    <button class='badge badge-opacity-warning' style={{ border: "0px" }}>Hold</button>
                                                                    <button class='badge badge-opacity-danger' style={{ border: "0px" }}>Cancelled</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <div class="card">
                                                            <div class="card-body">
                                                                <Row>
                                                                    <div class="col-md-2">
                                                                        <Checkbox id="selectAll" isChecked={selectedCheckboxes.length === page_size} onChange={handleSelectAllChange} /> Select All
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button class="btn btn-primary" style={{ color: '#fff' }} onClick={() => { HandlePaymentRequest(); }}>Payment Request</button>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button class="btn btn-dark" style={{ color: '#fff' }} onClick={() => { HandleBorzoRequest(); }}>Borzo Request</button>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button class="btn btn-danger" style={{ color: '#fff' }} onClick={() => { HandleSendBill(); }}>Send Bills</button>
                                                                    </div>
                                                                    <div class="col-md-2">
                                                                        <button class="btn btn-warning" style={{ color: '#fff' }}>Notify</button>
                                                                    </div>
                                                                </Row>
                                                            </div>
                                                        </div>
                                                        <div class="table-responsive  mt-1" id="printme">
                                                            <DataTable
                                                                columns={columns}
                                                                data={filter}
                                                                pagination
                                                                paginationServer
                                                                paginationTotalRows={totalRows}
                                                                onChangePage={handlePageChange}
                                                                onChangeRowsPerPage={handlePerRowsChange}
                                                                actions={<button className="btn btn-success">Export to PDF</button>}
                                                                subHeader
                                                                subHeaderComponent={
                                                                    <input id="search" type="text" className="w-25 form-control" placeholder="Search..." value={search} onChange={handleSearch} />
                                                                }
                                                                customStyles={tableHeaderStyle}
                                                                conditionalRowStyles={conditionalRowStyles}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <Footer /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestSalesAll, requestBorzoDelivery, requestSendBill, requestPayments }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaleList);